import { render, staticRenderFns } from "./BookingInventoryProducts.vue?vue&type=template&id=381253bd&scoped=true&"
import script from "./BookingInventoryProducts.vue?vue&type=script&lang=ts&"
export * from "./BookingInventoryProducts.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./BookingInventoryProducts.vue?vue&type=style&index=1&id=381253bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381253bd",
  null
  
)

export default component.exports